module.exports = __webpack_public_path__ + "media/images/brands/brand-dp-28ca4c8288aad04dca1f682bde79e96e.jpg";